import { useSubAccountInfo } from "context/sub_account";
import { useAppServices } from "hook/services";
import { CheckCircle2, Loader2, Phone, SigmaIcon } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
export default function PhoneNumbersData() {
  const { locationId } = useParams();
  const {subaccount,Update}=useSubAccountInfo()
  const AppService = useAppServices();
  const [PhoneNumbers, setPhoneNumbers] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [processing, setProcessing] = useState(true);
  const [selectedNumber, setSelectedNumber] = useState<any>(null);

  const getPhoneNumbers = async () => {
    const { response, error } = await AppService.phone_bridge.sim.get({
      query: `locationId=${locationId}`,
    });
    if (response) {
      setPhoneNumbers(response.data);
      setLoading(false);
    } else {
      setPhoneNumbers([]);
      setLoading(false);
    }
  };
  let pageLoad = true;
  const onload = () => {
    if (pageLoad) {
      getPhoneNumbers();
      pageLoad = false;
    }
  };

  useEffect(() => {
    onload();
  }, []);

  const ConfigureNumber = async (simId: string) => {
    setProcessing(true);
    setSelectedNumber(simId);
    const payload = {
      defaultSim: simId,
      _id: locationId,
    };

    const { response } = await AppService.sub_account.update({ payload });
    if (response) {
      onload();
      Update(response.data)
    }
    setProcessing(false);
    setSelectedNumber(null);
  };

  const columns = useMemo(
    () => [
      {
        header: "Phone",
        accessorKey: "sim_number",
        enableColumnFilter: false,
        cell: ({ row }: any) => (
          <div className="flex items-center gap-2">
            <div className="p-2 rounded-md bg-blue-50 text-blue-600 dark:bg-blue-900/40 dark:text-blue-300">
              <Phone className="w-4 h-4" />
            </div>
            <span className="font-medium text-gray-800 dark:text-gray-200">
              {row.original.sim_number || "N/A"}
            </span>
          </div>
        ),
      },
      {
        header: "SIM Slot",
        accessorKey: "sim_slot",
        enableColumnFilter: false,
        cell: ({ row }: any) => (
          <div className="flex items-center gap-2">
            <div className="p-2 rounded-md bg-emerald-50 text-emerald-600 dark:bg-emerald-900/40 dark:text-emerald-300">
            <span className="text-gray-700 dark:text-gray-300">
              {row.original.sim_slot || "-"}
            </span>
            </div>
          </div>
        ),
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-2 justify-center">
            {subaccount?.defaultSim === cell?.row?.original?._id ? (
              <button
                disabled
                className="flex items-center gap-2 text-white text-sm px-3 py-1.5 rounded-md bg-custom-500 border border-custom-500 cursor-not-allowed opacity-80 transition-all duration-200"
              >
                <CheckCircle2 className="w-4 h-4" />
                Configured
              </button>
            ) : (
              <button
                disabled={
                  processing && selectedNumber === cell?.row?.original?._id
                }
                onClick={() => ConfigureNumber(cell?.row?.original?._id)}
                className={`flex items-center gap-2 text-white text-sm px-3 py-1.5 rounded-md bg-custom-500 border border-custom-500 hover:bg-custom-600 focus:ring-2 focus:ring-custom-100 transition-all duration-200 ${
                  processing && selectedNumber === cell?.row?.original?._id
                    ? "opacity-70 cursor-not-allowed"
                    : ""
                }`}
              >
                {processing && selectedNumber === cell?.row?.original?._id ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <SigmaIcon className="w-4 h-4" />
                    Make Default
                  </>
                )}
              </button>
            )}
          </div>
        ),
      },
    ],
    [subaccount]
  );
  return {
    loading: loading,
    PhoneNumbers: PhoneNumbers,
    columns: columns,
    handleRefresh: getPhoneNumbers,
  };
}
